import { opsDict } from '@/hooks/dictionary';
import { IdictValuesItem } from '@/api/dict/types';

export interface CustomObj {
  [propName: string]: IdictValuesItem[];
}

export const useDictionary = (codes: string[]) => {
  const dictMap = opsDict.getDicts(codes);
  return {
    batchDictListMap: dictMap,
  };
};
